import { speakerLogos } from "../data/speaker_logos";
import Marquee from "react-marquee-slider";

export const LogoCarouselTest = () => {
   return (
      <div
         style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#7C2387'
         }}>
         <div style={{ flex: 1.5 }}>
            <h1
               style={{
                  textAlign: 'center',
                  color: 'white',
                  fontWeight: '900',
                  display: window.innerWidth < 1000 ? 'none' : "", height: '100%'
               }}>
               OUR FEATURED VCs
            </h1>
         </div>
         <div style={{
            flex: 3,
            padding: '2%',
            backgroundColor: 'white',
            overflow: 'hidden'
         }}>
            <Marquee velocity={2} style={{ overflow: "hidden" }}>
               {
                  speakerLogos.map((item, i) =>
                     item.logo_url !== null ?
                        <div
                           key={i}
                           style={{
                              display: "flex",
                              alignItems: "center",
                              zIndex: "1001",
                              whiteSpace: "nowrap"
                           }}
                        >
                           <a href={item.website}>
                              <img
                                 alt='carousel-logo'
                                 className="carousel-logo"
                                 style={{
                                    objectFit: "scale-down",
                                    maxWidth: "175px",
                                    maxHeight: "100px",
                                    marginLeft: "1.5rem",
                                    marginRight: "1.5rem",
                                 }}
                                 src={item.logo_url}
                              />
                           </a>
                        </div>
                        :
                        <></>
                  )
               }
            </Marquee></div></div>
   );
};
